<div class=" mt-4" *ngIf="PayoutTour">
  <section class="my-4">
    <div class="scrollmenu">
      <a [routerLink]="['/PayOut/AccountBalance']">Account Balance</a>
      <a [routerLink]="['/PayOut/ManagePayOutContact']">PayOut Contact</a>
      <a [routerLink]="['/PayOut/BeneficiaryList']">PayOut Beneficiary</a>

      <!-- <a [routerLink]="['/PayOut/PayoutLedgers']">PayOut Ledger</a> -->
      <a routerLinkActive="active" class="active menu" [routerLink]="['/PayOut/PayOutTransactions']">PayOut
        Transaction</a>
      <a [routerLink]="['/PayOut/PayOutBatches']">PayOut settlement</a>
      <!-- <a [routerLink]="['/PayOut/managePayoutAccountdetails']">Payout Security</a> -->
<a [routerLink]="['/PayOut/ManagePayOutBulkUploadFiles']">Bulk File Upload</a>
<!-- <a  [routerLink]="['/PayOut/PayoutPostback']">PayOut PostBack Url</a> -->
<!-- <a [routerLink]="['/PayOut/PayoutReports']">Reports</a>
<a [routerLink]="['/PayOut/PayoutSecurityTransactions']">Payout Security Transactions</a> -->
    </div>
  </section>
  <section>
    <div class="row" *ngIf="Workclose">
      <div class="col-md-12">

        <div class="row">
          <div class="col-lg-12">
            <div class="card-1">
              <div >
                <h3 class="font-weight-bold d-inline">How it Works</h3>

                <a class="d-inline float-right" (click)="close()"><i class="fas fa-times"></i></a>

                <div class="hori-timeline pt-5 get-width" dir="ltr">
                  <ul class="list-inline events">
                    <li class="list-inline-item event-list">
                      <div class="px-4">
                        <div class="event-date bg-soft-primary text-white">Step 1</div>
                        <h5 class="font-weight-bold pb-3">Create Pay Button</h5>
                        <p class="text-muted">Create GST based invoices instantly and notify
                          your customer via sms or email.</p>

                      </div>

                    </li>
                    <li class="list-inline-item event-list">
                      <div class="px-4">
                        <div class="event-date bg-soft-success text-white">Step 2</div>
                        <h5 class="font-weight-bold pb-3"> Receive Payments</h5>
                        <p>Your customers can make payments directly via the invoice link.</p>
                        <div>

                        </div>
                      </div>
                    </li>

                  </ul>
                </div>
              </div>
            </div>
            <!-- end card -->
          </div>
        </div>

      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-12">
        <div class="float-right">
          <a  class="back-tour mr-3" type="a" data-bs-toggle="modal" data-bs-target="#exampleModalCenter">Need Help ?
            Take a Tour <i class="far fa-lightbulb"></i></a>
          <div class="dropdown d-inline">
            <button class="dash-btns mr-3" type="button" data-bs-toggle="dropdown">Download &nbsp;<i
                class="fas fa-caret-down"></i>
            </button>
            <ul class="dropdown-menu text-center">
              <li><a  id="btnExportBatch" (click)="readAndExportToExcelData()">Excel</a></li>

            </ul>
          </div>
          <!-- <a class="box-button" type="button" id="filtering" (click)="filters()" tooltip="Filter"
        aria-describedby="tooltip-9">  <img src="assets/img/filter-icon.png" alt="" style="width: 20px; height: 20px;"></a>
      -->
          <button class="btn dash-btns" type="button" id="filtering" (click)="filters()"><i class="fa fa-filter" aria-hidden="true"></i> Filter</button>

        </div>

      </div>
      <div class="col-md-12">
        <small class=" font-16 gary-t ">Currently we are displaying last 7 days report. For more details please click
          onFilter</small>
      </div>
    </div>

    <div class="row  my-4" *ngIf="filtering">
      <div class="col-md-12">
        <div class="card-1 p-4">
          <h4 class="font-26 gary-t">Filter Your Result</h4>
          <p>Please Fill the details to filter your result</p>

          <div class="col-md-12">
            <!-- filtering starts -->
            <form>
              <div class="row m-0">
                <div class="col-md-3 mt-4">

                  <div class="form-group">
                    <label class="customlabel">Date</label>
                    <div class="selectcustom">
                      <ngx-select [items]="Range" id="daterange" placeholder="Select date" [formControl]="daterange"
                      (ngModelChange)="checkRangeType()" required>
                    </ngx-select>
                    </div>

                  </div>
                </div>
                <div class="col-md-3 mt-4" *ngIf="Rfromdate">


                  <div class="form-group">
                    <label class="customlabel">From Date</label>
                    <input class="formcontrol-user1 form-control" type="date" placeholder="From Date" id="fromdate"
                      [formControl]="fromdate"  (change)="checkDateRange()">
                  </div>

                </div>
                <div class="col-md-3 mt-4" *ngIf="Rfromdate">

                  <div class="form-group">
                    <label class="customlabel">To Date</label>
                    <input class="formcontrol-user1 form-control" type="date" placeholder="To Date" id="todate"
                      [formControl]="todate"  (change)="checkDateRange()">
                  </div>
                </div>
                <span class="text-danger" *ngIf="isStartDateGreaterthenEndDate">From Date Should not be greater than To
                  Date</span>
                <!-- <div class="col-md-3  mt-4">
              <div class="form-group">
                <ngx-select [items]="Status" id="BankAccountType" placeholder="BankAccountType" [formControl]="BankAccountType" required>
                </ngx-select>
              </div>
            </div> -->
                <div class="col-md-3  mt-4">

                  <div class="form-group">
                    <label class="customlabel">Transaction ID</label>
                    <input class="formcontrol-user1 form-control" type="text" placeholder="Transaction Id"
                      id="TransactionId" [formControl]="TransactionId">
                  </div>
                </div>
                <div class="col-md-3  mt-4">
                  <label class="customlabel">Bank Name</label>
                  <div class="form-group">
                    <input class="formcontrol-user1 form-control" type="text" placeholder="Bank Name" id="BankName"
                      [formControl]="BankName">
                  </div>
                </div>

                <div class="col-md-3  mt-4">

                  <div class="form-group">
                    <label class="customlabel">Account Number</label>
                    <input class="formcontrol-user1 form-control" type="text" placeholder="Account Number" (keypress)="numberOnly($event)"
                      id="AccountNumber" [formControl]="AccountNumber">
                  </div>
                </div>
                <div class="col-md-3  mt-4">

                  <div class="form-group">
                    <label class="customlabel">Request UniqueId</label>
                    <input class="formcontrol-user1 form-control" type="text" placeholder="Request UniqueId"
                      id="requestid" [formControl]="requestid">
                  </div>
                </div>
                <div class="col-md-3  mt-4">

                  <div class="form-group">
                    <label class="customlabel">Amount</label>
                    <input class="formcontrol-user1 form-control" type="text" placeholder="Amount" id="Amount" (keypress)="numberOnly($event)"
                      [formControl]="Amount">
                  </div>
                </div>
                <div class="col-md-3 mt-4">

                  <div class="form-group">
                    <label class="customlabel">Select</label>
                    <div class="selectcustom mb-0">
                      <ngx-select [items]="symbol" id="amountcheck" placeholder="Select" [formControl]="amountcheck"
                      required>
                    </ngx-select>
                    </div>

                  </div>
                </div>
                <!-- <div class="col-md-3  mt-4">
              <div class="form-group">
                <input type="text" placeholder="PayOutKeyId" id="PayOutKeyId" [formControl]="PayOutKeyId">
              </div>
            </div> -->
            <div class="col-md-3 mt-4">

              <div class="form-group">
                <label class="customlabel">Payout Processor</label>
                <div class="selectcustom mb-0">
                  <ngx-select [items]="PayoutProcessorlist" id="PayoutProcessor" placeholder="PayoutProcessor" [formControl]="PayoutProcessor"
                  required>
                </ngx-select>
                </div>

              </div>
            </div>

              </div>
            </form>
            <!-- filtering ends -->
          </div>
          <div  class="col-md-12 mt-4 text-right">
            <div style="display: inline-block;  margin-right:5px;" class="text-right" *ngIf="!isCustomDateSelected">
              <button class="dash-btns" type="button" id="filtering" (click)="selectedaterange()"
                matTooltip="New Sale Transaction"> Search</button>
            </div>

            <div style="display: inline-block;  margin-right:5px;" class="text-right" *ngIf="isCustomDateSelected">
              <button class="dash-btns" type="button" id="filtering" [disabled]="!isreportsbtnActive" (click)="search()"
                matTooltip="New Sale Transaction"> Search</button>
            </div>
          

          <div style="display: inline-block;  margin-right:5px;" class="text-right">

            <button type="reset" class="dash-btns" (click)="resetForm()"

              matTooltip="New Sale Transaction">Reset</button>
            <!-- <a href="" style="color: #d40055;">Clear</a> -->
          </div>
        </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <ngx-datatable #table class='bootstrap no-detail-row' (columnMode)="'Force'" [footerHeight]="50"
          [rowHeight]="'auto'"[columnMode]="'force'" [scrollbarH]="true" [limit]="10" [rows]="rows" >
          <ngx-datatable-column name="Action">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <a class=" edit" [routerLink]="['/PayOut/ViewPayOutTransactions',{Id: row.TransactionId}]"
                data-toggle="tooltip" data-placement="top" title="View">
                <img src="./assets/ViewDetails.svg">
              </a>
              <a class="edit btn btn-demo" (click)="viewtransactiondetails(row.TransactionId,row.MerchantKeyId)" data-bs-toggle="modal" data-bs-target="#myModal2" data-placement="top" title="Basic View">
                <em class="fa-1x mr-2 fas fa-eye"></em>
              </a>
              <!-- <a class=" edit pl-1 d-inline"
              [routerLink]="['/PayOut/ViewPayOutTransactions',{Id: row.Id}]"
                            data-toggle="tooltip" data-placement="top" title="Edit"
                            > <i class="fas fa-edit"></i>
                        </a> -->

            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Status" [width]="180">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span class="status-warning-btn" *ngIf="row.Status==0">
                Pending
              </span>
              <span class="status-primary-btn" *ngIf="row.Status==1">
                Transaction Initiated
              </span>
              <span class="status-danger-btn" style="display: inline-block" *ngIf="row.Status==2">
                Failed
              </span>
              <span class="status-approved-btn" *ngIf="row.Status==3">
                Transferred
              </span>
              <span class="status-danger-btn" *ngIf="row.Status==4">
                Cancelled
              </span>
              <span class="status-danger-btn" *ngIf="row.Status==5">
                WaitingForApproval
              </span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Response">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class="robot font400">
                  {{row.ResponseText}}
              </div>
            </ng-template>

          </ngx-datatable-column>
          <ngx-datatable-column name="Transaction Type">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class="robot font400">{{row.TransactionType}}</div>
            </ng-template>

          </ngx-datatable-column>
          <ngx-datatable-column name="Amount">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class="robot font400"> {{row.Amount | currency:"₹" }}</div>
            </ng-template>
          </ngx-datatable-column>

          <!-- [width]="200" -->
          <ngx-datatable-column name="Transaction Id" [width]="200">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.TransactionId}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Request Unique Id" [width]="200">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.RequestUniqueId}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Account Number" [width]="200">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.AccountNumber}}
            </ng-template>
          </ngx-datatable-column>
          <!-- <ngx-datatable-column name="PayOutKeyId">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.PayOutKeyId}} </ng-template>
          </ngx-datatable-column> -->

          <ngx-datatable-column name="Beneficiary Name">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.BeneficiaryName}} </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Bank Name">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.BankName}} </ng-template>
          </ngx-datatable-column>


          <ngx-datatable-column name="Payment Type">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.PaymentType}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Reason">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.InternalPurpose}} </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Payout Processor" [width]="180">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span class="" *ngIf="row.PayoutProcessor==0">
                FastSwiffDemo
              </span>
              <span class="" *ngIf="row.PayoutProcessor==1">
                Indusind
              </span>
              <span class=""  *ngIf="row.PayoutProcessor==2">
                YesBank
              </span>
              <span class="" *ngIf="row.PayoutProcessor==3">
                AxisBank
              </span>
              <span class="" *ngIf="row.PayoutProcessor==4">
                IDFC
              </span>
            </ng-template>
          </ngx-datatable-column>


          <!-- <ngx-datatable-column name="ResponseText">
            <ng-template let-row="row" ngx-datatable-cell-template><div class=" robot font400">{{row.ResponseText}}</div></ng-template>
          </ngx-datatable-column> -->
          <ngx-datatable-column name="Updated Date Time">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class=" robot font400">{{row.UpdatedDatetime| date:'d/M/yy, h:mm a'}}</div>
            </ng-template>
          </ngx-datatable-column>




        </ngx-datatable>
      </div>
    </div>
  </section>
</div>



<!-- Tour strats -->

<div class="" *ngIf="tourDiv">
  <div class="">
    <div class="row">
      <div class="col-md-12">
        <div class="pt-5 text-right">
          <button class="btn btn-warning" (click)="SkipTour()">Skip <i class="fas fa-step-forward"></i></button>

        </div>
      </div>
    </div>
  </div>
  <div class="" *ngIf="PayoutStep1">
    <div class="one">
      <div class="row  tourstep">
        <div class="col-md-6  d-none d-sm-none d-md-block">
          <img class="w-100 mt-3" src="http://fastswiff.com/assets/img/vpos-tour-images/payout/manage-payout.png"
            style="width: 350px ;">
        </div>
        <div class="col-md-6">
          <div class="mt-5  py-3">
            <img src="assets/img/logo.png" style="width: 100px;">
          </div>
          <h3 style="font-size: 35px; line-height: 48px;
                  margin: 16px 0 8px 0; font-weight: bold;
                  color: #0d2366;">Manage PayOut Transactions </h3>
          <ul class="padding-b-xs">
            <li>No developer, no problem.. we are here to help you.</li>
            <li>Keep it simple with our dashboard payouts </li>
            <li>Make payouts easily and quickly from the dashboard.</li>
            <li>Start making payouts by entering payee's account details or UPI handle in minutes.</li>
          </ul>


          <div class="pt-5 text-right" style="vertical-align: bottom;     position: absolute;
                  bottom: 17px;
                  right: 64px;">
            <button class="box-button" (click)="Nextstep() ">Next</button>

          </div>


          <div class="pt-5 text-right" style="vertical-align: bottom;     position: absolute;
                   bottom: 17px;
                    bottom: 25px;
                    right: 150px;">
            <input class="d-inline mb-0 mr-2" type="checkbox" (click)="ShowMeAgain()" />
            <p class="d-inline mb-0 text-primary">Do not show me again</p>

          </div>
        </div>
      </div>
    </div>


  </div>

  <div class="" *ngIf="PayoutStep2">
    <div class="one">
      <div class="row  tourstep tourstep1">
        <div class="col-md-12">
          <h3 style="font-size: 25px; line-height: 48px;margin: 16px 0 8px 0; font-weight: bold;
            color: #0067ef94;">Payouts transaction- Today and tomorrow!</h3>

          <div class="col-md-6">
            <img class="Feature-icon" src="http://fastswiff.com/assets/img/vpos-tour-images/payout/upload-icon.png">
            <h3 style="font-size: 15px; line-height: 48px;margin: 16px 0 8px 0; font-weight: bold;
                color: #0d2366;">Send Bulk Payouts with just one click</h3>

            <p class="Feature-desc ">FastSwiff supports unlimited payments with a single excel file upload. That's better
              than any other bank.</p>
          </div>
          <div class="col-md-6">
            <img class="Feature-icon " src="http://fastswiff.com/assets/img/vpos-tour-images/payout/api-icon.png">
            <h3 style="font-size: 15px; line-height: 48px;margin: 16px 0 8px 0; font-weight: bold;
              color: #0d2366;">Automate payout flows across your business</h3>
            <p class="Feature-desc ">Integrate and launch our Payouts API in hours.</p>
            <p class="Feature-desc ">Send thousands of payments per second without any effort.</p>
          </div>

          <div class="pt-5 text-right" style="vertical-align: bottom;     position: absolute;
            bottom: 24px;
     right: 185px;
     font-size: 18px;
     cursor: pointer;;">
            <a class="box-a" (click)="backSubmit()">Back</a>

          </div>
          <div class="pt-5 text-right" style="vertical-align: bottom;     position: absolute;
         bottom: 17px;
         right: 64px;">
            <button class="box-button" (click)="GetStarted()">Get Started</button>

          </div>
        </div>




      </div>
    </div>

  </div>

</div>
<!-- tour Ends -->

<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content card-1 p-1">
      <div class="modal-header" style="border-bottom:none">

        <button type="button" class="close blue1-t font-16" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">Skip</span>
        </button>
      </div>
      <div class="modal-body" style="border-bottom:none">
        <div class="row ">
          <div class="mx-auto mb-2">
            <img src="assets/img/new/tour.svg" alt="" height="150">
          </div>
          <div class="col-md-12 text-center">
            <div *ngIf="step1">
              <h4 class="gary-t font-20 pt-3 ">Manage PayOut Transactions </h4>
              <div class="lite-gray-t py-2">
                <ul class="padding-b-xs text-left">
                  <li>No developer, no problem.. we are here to help you.</li>
                  <li>Keep it simple with our dashboard payouts </li>
                  <li>Make payouts easily and quickly from the dashboard.</li>
                  <li>Start making payouts by entering payee's account details or UPI handle in minutes.</li>
                </ul>
              </div>
              <div class=" text-center">
                <button class="btn blue-btn" (click)="next2()">Next</button>
              </div>
            </div>
            <div *ngIf="step2">
              <h4 class="gary-t font-20 pt-3 ">Payouts transaction- Today and tomorrow!</h4>


              <div class="col-md-12">
                <div class="">

                  <div class="Feature-title">Send Bulk Payouts with just one click</div>
                  <p class="lite-gray-t py-2">FastSwiff supports unlimited payments with a single excel file upload. That's
                    better than any other bank. </p>
                </div>
              </div>



              <div class=" text-center">
                <button class="btn blue-btn" (click)="next3()">Next</button>
                <a type="a" class="lite-gra-t font-16 d-block mt-2" (click)="back1()" style="color: #262626;">Back</a>
              </div>
            </div>
            <div *ngIf="step3">
              <h4 class="gary-t font-20 pt-3 ">Payouts transaction- Today and tomorrow!</h4>
              <div class="col-md-12">
                <div class="">

                  <div class="Feature-title">Automate payout flows across your business</div>
                  <p class="Feature-desc ">Integrate and launch our Payouts API in hours.</p>
                  <p class="Feature-desc ">Send thousands of payments per second without any effort.</p>
                </div>
              </div>
              <div class=" text-center">
                <button class="btn blue-btn" data-bs-dismiss="modal" aria-label="Close" type="button">Get
                  Started</button>
                <a type="a" class="lite-gra-t font-16 d-block mt-2" (click)="back2()" style="color: #262626;">Back</a>
              </div>
            </div>


          </div>
        </div>
      </div>

    </div>
  </div>
</div><div class="modal right fade" id="myModal2" tabindex="-1" role="dialog" aria-labelledby="myModalLabel2">
  <div class="modal-dialog" role="document">
    <div class="modal-content">

      <div class="modal-header">
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
         <h4 class="modal-title" id="myModalLabel2">View Transaction Details</h4>
      </div>

      <div class="modal-body">
        <div class="row mt-3 mb-3">
          <div class="col-md-12">
            <div class="row  my-3">
                <div class="col-md-6">
                    <label>Status</label>
                </div>
                <div class="col-md-6">
                    <div class="view-text"> <span class="text-warning" *ngIf="rowdata.Status==0">
                      Pending
                    </span>
                    <span class="text-success" *ngIf="rowdata.Status==1">
                      Transaction Initiated
                    </span>
                    <span class="text-danger" *ngIf="rowdata.Status==2">
                      Failed
                    </span>
                    <span class="text-success" *ngIf="rowdata.Status==3">
                      Transferred
                    </span>
                    <span class="text-danger" *ngIf="rowdata.Status==4">
                      Cancelled
                    </span>
                    <span class="text-danger" *ngIf="rowdata.Status==5">
                     Waiting For Approval
                    </span> </div>


                </div>
            </div>
            <div class="row my-3">
                <div class="col-md-6">
                    <label>Amount
                    </label>
                </div>
                <div class="col-md-6">
                    <div class="view-text"> {{rowdata.Amount}}</div>
                </div>
            </div>
            <div class="row my-3">
                <div class="col-md-6"> <label>TransactionId</label> </div>

                <div class="col-md-6 view-text "> {{rowdata.TransactionId}}
                </div>
            </div>
            <div class="row my-3">
                <div class="col-md-6"> <label>GST Amount</label> </div>

                <div class="col-md-6 view-text  ">{{rowdata.GSTAmount}} </div>
            </div>

            <div class="row my-3">
                <div class="col-md-6">
                    <label>Total Amount </label>
                </div>
                <div class="col-md-6 view-text "> {{rowdata.Amount + rowdata.TotalFeeAmount | number : '1.2-2'}}</div>
            </div>
            <div class="row my-3">
                <div class="col-md-6">
                    <label>Fee Amount</label>
                </div>
                <div class="col-md-6 view-text">{{rowdata.FeeAmount}}</div>
            </div>
            <div class="row my-3">
                <div class="col-md-6">
                    <label>Total Fee Amount </label>
                </div>
                <div class="col-md-6 view-text">{{rowdata.TotalFeeAmount}}</div>
            </div>
            <div class="row my-3">
                <div class="col-md-6">
                    <label>Transaction Type</label>
                </div>
                <div class="col-md-6 view-text">{{rowdata.TransactionType}}
                </div>
            </div>



            <div class="row my-3">

                <div class="col-md-6">
                    <label>PaymentType</label>
                </div>

                <div class="col-md-6 view-text">{{rowdata.PaymentType}}</div>
            </div>

            <div class="row my-3">
                <div class="col-md-6">
                    <label>PayOut Beneficiary KeyId </label>
                </div>

                <div class="col-md-6 view-text">{{rowdata.PayOutBeneficiaryKeyId}}</div>
            </div>
            <div class="row my-3">
                <div class="col-md-6">
                    <label>Payout CustomerkeyId</label>
                </div>

                <div class="col-md-6 view-text">{{rowdata.PayoutCustomerkeyId}}</div>
            </div>






        </div>
        <div class="col-md-12">
            <div class="row my-3">

                <div class="col-md-6">
                    <label>Bank Code Type </label>
                </div>

                <div class="col-md-6 view-text">{{rowdata.BankCodeType}}</div>
            </div>
            <div class="row my-3">

                <div class="col-md-6">
                    <label> BankName</label>
                </div>

                <div class="col-md-6 view-text robot">{{rowdata.BankName}} </div>
            </div>
            <div class="row my-3">

                <div class="col-md-6">
                    <label>UTRNo </label>
                </div>

                <div class="col-md-6 view-text">{{rowdata.UTRNo}} </div>

            </div>

            <div class="row my-3">

                <div class="col-md-6">
                    <label>PayOut Date </label>
                </div>

                <div class="col-md-6 view-text">{{rowdata.PayOutDate |
                  date:'d/M/yy, h:mm a' }}</div>

            </div>

            <div class="row my-3">

              <div class="col-md-6">
                  <label>PayOut KeyId </label>
              </div>

              <div class="col-md-6 view-text">{{rowdata.PayOutKeyId}}</div>

          </div>
          <div class="row my-3">

            <div class="col-md-6">
                <label>PayOut Type </label>
            </div>

            <div class="col-md-6 view-text">{{rowdata.PayOutType}}</div>

        </div>
        <div class="row my-3">

          <div class="col-md-6">
              <label>AccountNumber </label>
          </div>

          <div class="col-md-6 view-text">{{rowdata.AccountNumber}}</div>

      </div>
      <div class="row my-3">

        <div class="col-md-6">
            <label>Branch Name </label>
        </div>

        <div class="col-md-6 view-text">{{rowdata.BranchName }}</div>

    </div>
    <div class="row my-3">

      <div class="col-md-6">
          <label>BankCode/IFSC Code </label>
      </div>

      <div class="col-md-6 view-text">{{rowdata.BankCode }}</div>

  </div>



    <div class="row my-3">

      <div class="col-md-6">
          <label>Beneficiary Name </label>
      </div>

      <div class="col-md-6 view-text">{{rowdata.BeneficiaryName }}</div>

  </div>
  <div class="row my-3">

    <div class="col-md-6">
        <label>Bank Account Type </label>
    </div>

    <div class="col-md-6 view-text">{{rowdata.BankAccountType }}</div>

</div>
<div class="row my-3">

  <div class="col-md-6">
      <label>Request Reference No</label>
  </div>

  <div class="col-md-6 view-text">{{rowdata.RequestReferenceNo }}</div>

</div>
<div class="row my-3">

  <div class="col-md-6">
      <label>Request UniqueId</label>
  </div>

  <div class="col-md-6 view-text">{{rowdata.RequestUniqueId }}</div>

</div>
<div class="row my-3">

  <div class="col-md-6">
      <label>Response Text</label>
  </div>

  <div class="col-md-6 view-text">{{rowdata.ResponseText }}</div>

</div>
<div class="row my-3">

  <div class="col-md-6">
      <label>Response Reason Code</label>
  </div>

  <div class="col-md-6 view-text">{{rowdata.ResponseReasonCode }}</div>

</div>
<div class="row my-3">

  <div class="col-md-6">
      <label>Updated Date time</label>
  </div>

  <div class="col-md-6 view-text">{{rowdata.UpdatedDatetime| date:'d/M/yy,
    h:mm a'}}</div>

</div>





        </div>
        </div>
      </div>

    </div><!-- modal-content -->
  </div><!-- modal-dialog -->
</div><!-- modal -->
